/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first column becomes the x-axis (for example months).`)
};

const es_line_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La primera columna se convierte en el eje X (por ejemplo, meses).`)
};

const de_line_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die erste Spalte wird zur x-Achse (zum Beispiel Monate).`)
};

const nl_line_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De eerste kolom wordt de x-as (bijvoorbeeld maanden).`)
};

const fr_line_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La première colonne devient l'axe des x (par exemple les mois).`)
};

const it_line_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La prima colonna diventa l'asse x (per esempio i mesi).`)
};

const pt_br2_line_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A primeira coluna se torna o eixo x (por exemplo, meses).`)
};

const pt_line_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A primeira coluna torna-se o eixo X (por exemplo, meses).`)
};

const ja_line_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初の列がx軸になります（例: 月）。`)
};

const zh_line_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第一列成为 x 轴（例如月份）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_ex3", locale)
	if (locale === "en") return en_line_ex3(inputs)
	if (locale === "es") return es_line_ex3(inputs)
	if (locale === "de") return de_line_ex3(inputs)
	if (locale === "nl") return nl_line_ex3(inputs)
	if (locale === "fr") return fr_line_ex3(inputs)
	if (locale === "it") return it_line_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_line_ex3(inputs)
	if (locale === "pt") return pt_line_ex3(inputs)
	if (locale === "ja") return ja_line_ex3(inputs)
	return zh_line_ex3(inputs)
};